export default __webpack_public_path__ + "static/media/dropdownIcon.daf0a211.svg";